<mat-toolbar class="toolbar-component">
  <mat-toolbar-row class="toolbar-component-row">
    <div
      class="toolbar-logo-container"
      *ngIf="!(exibirNavegacaoPesquisaMobile$ | async)"
    >
      <mat-icon
        class="logo"
        [svgIcon]="(breakpointMd$ | async) ? 'logo-md' : 'logo-lg'"
      ></mat-icon>
    </div>
    <div class="toolbar-spacer"></div>

    <app-navegacao-pesquisa-leis
      *ngIf="
        !(breakpointLg$ | async) || (exibirNavegacaoPesquisaMobile$ | async)
      "
      class="app-navegacao-container"
    ></app-navegacao-pesquisa-leis>

    <div class="toolbar-spacer"></div>

    <div
      class="toolbar-icons-container"
      *ngIf="!(exibirNavegacaoPesquisaMobile$ | async)"
    >
      <button
        mat-icon-button
        *ngIf="
          (breakpointLg$ | async) && !(exibirNavegacaoPesquisaMobile$ | async)
        "
        (click)="exibirPesquisaMobileClick()"
        class="navbar-button-icon navbar-icon-pesquisa"
        aria-label="Pesquisa"
      >
        <mat-icon matTooltip="Pesquise em todas as leis"> search </mat-icon>
      </button>

      <button
        mat-icon-button
        matTooltip="Uma nova versão está disponível, clique aqui para atualizar"
        class="navbar-button-icon navbar-icon-atualizar"
        aria-label="atualizar"
        (click)="atualizarApp()"
        *ngIf="updateAvailable$ | async"
      >
        <mat-icon svgIcon="clock-rotate-left"></mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="btnFeedbackClick()"
        class="navbar-button-icon navbar-icon-helper"
        aria-label="Feedback"
        *ngIf="!(appOffline$ | async)"
      >
        <mat-icon
          svgIcon="question-circle"
          matTooltip="Dê seu feedback e nos ajude a melhorar"
        >
        </mat-icon>
      </button>

      <app-historico-atualizacoes
        matTooltip="Histórico atualizações"
        class="flex-row center-center"
      ></app-historico-atualizacoes>

      <div class="user-menu flex-row center-center">
        <a
          matTooltip="Meu perfil"
          class="flex-row center-center profile-photo-button"
          [matMenuTriggerFor]="menu"
        >
          <ng-container *ngIf="false; else Empty">
            <img src="{{ model.userFoto }}" class="profile-photo" />
          </ng-container>
        </a>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<mat-toolbar class="toolbar-component-second">
  <mat-toolbar-row class="toolbar-component-row-second">
    <app-navegacao-leis-ramos-direito class="navegacao-leis-ramos">
    </app-navegacao-leis-ramos-direito>
    <app-navegacao-favoritos class="navegacao-leis-favorito">
    </app-navegacao-favoritos>
  </mat-toolbar-row>

  <mat-menu #menu="matMenu" class="navbar-menu">
    <div class="navbar-menu-container">
      <button
        class="navbar-menu-button navbar-menu-button-user"
        mat-menu-item
        (click)="lnkPerfilClick($event)"
        *ngIf="!(appOffline$ | async)"
      >
        <ng-container *ngIf="false; else Empty">
          <img src="{{ model.userFoto }}" class="profile-photo" />
        </ng-container>

        <span class="span-navbar-menu-user">
          <span class="username-wrapper">{{ model.userNome }}</span>
          <app-indicador-trial
            class="navbar-indicador-trial"
          ></app-indicador-trial>
        </span>
      </button>
      <button
        class="navbar-menu-button"
        mat-menu-item
        (click)="lnkPreferenciasClick($event)"
      >
        <mat-icon class="icon-navbar-gear" svgIcon="gear"></mat-icon>
        <span>Preferências</span>
      </button>

      <button
        class="navbar-menu-button"
        mat-menu-item
        (click)="logoff()"
        *ngIf="!(appOffline$ | async)"
      >
        <mat-icon
          svgIcon="arrow-right-from-bracket"
          class="icon-navbar-arrow-right-from-bracket"
        ></mat-icon>
        <span>Sair</span>
      </button>
    </div>
  </mat-menu>
</mat-toolbar>

<ng-template #Empty>
  <span class="span-icon-navbar-user">
    <mat-icon class="icon-navbar-user" svgIcon="user"></mat-icon>
  </span>
</ng-template>
